<template>
  <div class="order">
    <van-nav-bar title="通讯录" left-arrow @click-left="$router.go(-1)" />
    <van-cell-group class="access_box">
      <van-cell title="学校-通讯录" is-link @click="goToBooks(1)" icon="/img/teacher.png" />
      <van-cell title="家长-通讯录" is-link @click="goToBooks(2)" icon="/img/parents.png" />
    </van-cell-group>
  </div>
</template>

<script>

export default {
  name: 'SchoolBook',
  components: {

  },
  data() {
    return {
      currentClass: {}
    }
  },
  mounted() {
    this.currentClass = JSON.parse(localStorage.getItem('currentClass'))
  },
  methods: {
    goToBooks(type) {
      if (type == 1) {
        this.$router.push({ path: '/schoolbook' })
      } else if (type == 2) {
        this.$router.push({ path: '/parentbook', query: { classname: this.currentClass.name } })
      }
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}

.van-tabs {
  position: sticky;
  top: 0;
}

.search-btn {
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}

.access_box {
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
